export function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden="true">
      B
    </span>
  );
}
